<template>
  <div class="com-box" :class="{'margin-15': creationMode}">
    <div class="com-title">
      活动说明
      <!-- <span class="title-tip">(自定义文字说明栏,非必填)</span> -->
    </div>
    <div class="com-content">
      <van-field
        class="title-input"
        v-model="form.attentionTitle"
        placeholder="自定义标题(非必填项，最多填写10个字)"
        :maxlength="10"
        @blur="onFormChange"
      />
      <van-field
        class="textarea-input"
        v-model="form.attentionMsg"
        rows="2"
        autosize
        type="textarea"
        placeholder="请输入文本内容"
        @blur="onFormChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Object
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.initForm(newVal);
        }
      },
      deep: true,
      immediate: true
    },
  },
  computed: {
    // 组件创建方式
    creationMode() {
      return this.$route.query.creationMode != 'new' ? true : false
    }
  },
  data() {
    return {
      form: {
        attentionTitle: '',
        attentionMsg: ''
      }
    }
  },
  methods: {
    initForm(val) {
      if (val) {
        this.form = {...val};
      }
    },
    onFormChange() {
      this.$emit('change', this.form);
    },
  }
}
</script>

<style lang="stylus" scoped>
.com-box
  // margin 15px 0
  .com-title
    padding 0 15px
    font-size 14px
    font-weight bold
    color #303133
    .title-tip
      margin-left 10px
      font-size 12px
      color #999
  .com-content
    margin 10px 15px
    padding 15px
    background-color: #fff
    border-radius: 8px
    .title-input
      padding-top 0
    .textarea-input
      background-color: #f4f4f4
      border-radius: 5px
.margin-15 {
  margin 15px 0
}
</style>